let count = 0;
import { useRef } from 'react';

/**
 * @param {?string} prefix
 * @return {string} An id string that's unique for that prefix
 */
export default function useUniqueId(prefix) {
  const idRef = useRef(undefined);
  // eslint-disable-next-line react-hooks/refs
  if (!idRef.current) {
    // eslint-disable-next-line react-hooks/globals
    count += 1;
    idRef.current = `${prefix}${count}`;
  }
  // eslint-disable-next-line react-hooks/refs
  return idRef.current;
}